// src/i18n.js
import { createI18n } from 'vue-i18n'

// carrega *.json de /locales (webpack)
function loadLocaleMessages () {
  const ctx = require.context('./locales', false, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  ctx.keys().forEach(key => {
    const locale = key.match(/([A-Za-z0-9-_]+)\./i)?.[1]
    if (locale) messages[locale] = ctx(key)
  })
  return messages
}

const i18n = createI18n({
  legacy: false,            // << usar Composition API
  globalInjection: true,    // permite usar $t nos templates
  locale: process.env.VUE_APP_I18N_LOCALE || 'pt',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

export default i18n
